<header>
  <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
    <span class="icon-view-close" aria-hidden="true">
      <svg>
        <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
      </svg>
    </span>
    <span>{{ 'generic.close' | translate }}</span>
  </button>
</header>
<div class="zoom-image-container">
  <img [src]="imgSrc" />
</div>
<footer class="mt-4 text-center">
  <ng-casto-btn class="light-grey" [loading]="dlLoading" (click)="download()" label="Télécharger"></ng-casto-btn>
  <ng-casto-btn class="light-grey" [loading]="printLoading" (click)="print()" label="Imprimer"></ng-casto-btn>
</footer>
